'use client';

import Link from 'next/link';
import styles from './CtaSection.module.scss';
import { ArrowRight, Phone } from 'lucide-react';
import { gaCta } from '@/src/helpers/gtag';
import { useAOS } from '@/src/lib/hooks/useAOS';

interface CtaSectionProps {
  title: string;
  highlightedTitle: string;
  description: string;
  primaryCta: string;
  primaryHref: string;
  secondaryCta: string;
  secondaryHref: string;
}

export function CtaSection({
  title,
  highlightedTitle,
  description,
  primaryCta,
  primaryHref,
  secondaryCta,
  secondaryHref,
}: CtaSectionProps) {
  useAOS();

  return (
    <section className={styles.section} aria-label="Appel à l'action">
      <div className={styles.orbTop} aria-hidden="true" />
      <div className={styles.orbBottom} aria-hidden="true" />

      <div className={styles.container}>
        <h2 className={styles.title} data-aos="fade-down" data-aos-duration="700">
          {title} <em>{highlightedTitle}</em>
        </h2>
        <div className={styles.right}>
          <p
            className={styles.description}
            data-aos="fade-down"
            data-aos-duration="700"
            data-aos-delay="100"
          >
            {description}
          </p>
          <div
            className={styles.ctaRow}
            data-aos="fade-down"
            data-aos-duration="700"
            data-aos-delay="200"
          >
            <Link
              href={primaryHref}
              className={styles.btnPrimary}
              onClick={() => gaCta(primaryCta, 'cta_section_primary', primaryHref)}
            >
              <Phone size={16} aria-hidden="true" />
              {primaryCta}
            </Link>
            <Link
              href={secondaryHref}
              className={styles.btnSecondary}
              onClick={() => gaCta(secondaryCta, 'cta_section_secondary', secondaryHref)}
            >
              {secondaryCta}
              <ArrowRight size={18} aria-hidden="true" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
